module.exports = __webpack_public_path__ + "static/media/createPhoneNumber_success.4447c1e4.svg";